import { render } from "./TownHome.vue?vue&type=template&id=ebc98488&scoped=true"
import script from "./TownHome.vue?vue&type=script&lang=js"
export * from "./TownHome.vue?vue&type=script&lang=js"

import "./TownHome.vue?vue&type=style&index=0&id=ebc98488&scoped=true&lang=stylus"
import "./TownHome.vue?vue&type=style&index=1&lang=css"
script.render = render
script.__scopeId = "data-v-ebc98488"

export default script